export default __webpack_public_path__ + "static/media/3d-face.fdae8cac.jpg";